export default `float s=3., e;
    for(int i=0;i++<8;)
      p=mod(p-1.,2.)-1.,
      s*=e=1.4/dot(p,p),
      p*=e;
    return length(p.yz)/s;
  }`